import { itemTypes } from '../geoTypeUtils';

const clickOnGuestRating = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'resortInfo_guest_click',
      eventCategory: 'Resort Info',
      eventAction: 'Click Guest Rating',
      eventLabel: '',
    });
  }
};

const clickOnMoreRatings = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'resortInfo_more_ratings',
      eventCategory: 'Resort Info',
      eventAction: 'Click More Ratings',
      eventLabel: '',
    });
  }
};

const clickOnMoreAbout = (isExpanded, geographicalItemType) => {
  if (window.dataLayer && isExpanded && geographicalItemType) {
    switch (geographicalItemType) {
      case itemTypes.resort:
        window.dataLayer.push({
          event: 'resortInfo_more_about',
          eventCategory: 'Resort Info',
          eventAction: 'Click More Info',
          eventLabel: '',
        });
        break;
      case itemTypes.area:
        window.dataLayer.push({
          event: 'areaInfo_read_more',
          eventCategory: 'Area Info',
          eventAction: 'Click More Info',
          eventLabel: 'None',
        });
        break;
      case itemTypes.country:
        window.dataLayer.push({
          event: 'countryInfo_read_more',
          eventCategory: 'Country Info',
          eventAction: 'Click More Info',
          eventLabel: 'None',
        });
        break;
      case itemTypes.region:
        window.dataLayer.push({
          event: 'regionInfo_read_more',
          eventCategory: 'Region Info',
          eventAction: 'Click More Info',
          eventLabel: 'None',
        });
        break;
      default:
    }
  }
};

const clickOnResortsLink = (itemType) => {
  if (window.dataLayer && itemType) {
    switch (itemType) {
      case itemTypes.area:
        window.dataLayer.push({
          event: 'area_click_destinations',
          eventCategory: 'Area Info',
          eventAction: 'Click Resorts',
          eventLabel: 'None',
        });
        break;
      case itemTypes.country:
        window.dataLayer.push({
          event: 'country_click_see_destinations',
          eventCategory: 'Country Info',
          eventAction: 'Click See Destinations',
          eventLabel: 'None',
        });
        break;
      case itemTypes.region:
        window.dataLayer.push({
          event: 'region_click_see_destinations',
          eventCategory: 'Region Info',
          eventAction: 'Click See Destinations',
          eventLabel: 'None',
        });
        break;
      default:
    }
  }
};

const clickOnHotelsButton = (itemType) => {
  if (window.dataLayer) {
    switch (itemType) {
      case itemTypes.country:
        window.dataLayer.push({
          event: 'country_click_find_hotel',
          eventCategory: 'Country Info',
          eventAction: 'Click Find Hotels',
          eventLabel: 'None',
        });
        break;
      case itemTypes.region:
        window.dataLayer.push({
          event: 'region_click_find_hotel',
          eventCategory: 'Region Info',
          eventAction: 'Click Find Hotels',
          eventLabel: 'None',
        });
        break;
      default:
    }
  }
};

export {
  clickOnGuestRating,
  clickOnMoreRatings,
  clickOnMoreAbout,
  clickOnResortsLink,
  clickOnHotelsButton,
};
